import { render } from "./produksiBenih.vue?vue&type=template&id=0f23a9fd"
import script from "./produksiBenih.vue?vue&type=script&lang=js"
export * from "./produksiBenih.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__